import DataGrid from "./DataGrid/DataGrid.tsx";

const ExpiringPoliciesDataGrid = ({
  policies,
  isLoading,
  fromDate,
  toDate,
}) => {
  const columns = [
    {
      name: "company",
      header: "ЗК",
      minWidth: 100,
      type: "string",
    },
    {
      name: "policyNumber",
      header: "№ Полица",
      minWidth: 140,
      type: "string",
    },
    {
      name: "policyType",
      header: "Вид полица",
      minWidth: 150,
      type: "string",
    },
    {
      name: "agent",
      header: "Агент",
      minWidth: 100,
      type: "string",
    },
    {
      name: "office",
      header: "Офис",
      minWidth: 100,
      type: "string",
    },
    {
      name: "fromDate",
      header: "От дата",
      minWidth: 100,
      type: "date",
    },
    {
      name: "toDate",
      header: "До дата",
      minWidth: 100,
      type: "date",
    },
    {
      name: "policySum",
      header: "Премия",
      minWidth: 100,
      type: "string",
    },
    {
      name: "vehicleRegistrationNumber",
      header: "Номер МПС",
      minWidth: 100,
      type: "string",
    },
    {
      name: "vehicleBrand",
      header: "Марка МПС",
      minWidth: 100,
      type: "string",
    },
    {
      name: "clientName",
      header: "Застрахован",
      minWidth: 150,
      type: "string",
    },
    {
      name: "clientPhoneNumber",
      header: "Телефон",
      minWidth: 100,
      type: "string",
    },
    {
      name: "additionalPolicyData",
      header: "Допълнителна информация",
      minWidth: 250,
      type: "string",
    },
  ];

  return (
    <DataGrid
      columns={columns}
      dataSource={policies}
      isLoading={isLoading}
      onEditComplete={() => {}}
      gridTitle="Изтичащи полици"
      idProperty="policyNumber"
      csvFilename={`Изтичащи-${fromDate}-${toDate}.csv`}
      icon="fa-kit fa-regular-file-circle-question"
    />
  );
};

export default ExpiringPoliciesDataGrid;
